goog.provide('el8.apphome.navtriggers');

goog.require('el8.appshared.dialog.createPatient');
goog.require('el8.appshared.dialog.viewEducationalHandouts');
goog.require('el8.apphome.docMgr.navMenu');
goog.require('el8.service.urls');

// TODOSIDNEYDELETE - functionality has been migrated to React
el8.apphome.navtriggers = (function() {

    return {

        setup: function() {

            $(document).on('click', '#choose_document_manager_trigger', function(event) {
                el8.apphome.docMgr.navMenu.displayUnfiledInboxesMenu($(this));
                return false;
            });
            $(document).on('click', '.create_patient_trigger', function(event) {
                event.preventDefault();
                el8.appshared.dialog.createPatient.show({
                    amplitudeSource: 'new-chart'
                });
            });
            $(document).on('click', '.educational-handouts-trigger', function(event) {
                event.preventDefault();
                el8.appshared.dialog.viewEducationalHandouts.show();
            });
            // Activate billing report trigger
            $(document).on('click', '.billing_report_trigger', function(event) {
                event.preventDefault();
                window.open(el8.service.urls.get('billingReport'));
            });
        }
    };

})();
